<template>
  <div>
    <b-row v-if="!auto_infracao_transito.isCancelado()">
      <b-col cols="4">
        <b-form-group label-size="sm" label-class="text-secondary">
          <template slot="label"
            ><span>Prazo Identificação Condutor Infrator - FICI&nbsp;</span
            ><b-icon
              v-b-tooltip.hover
              title="FICI - Identificação do Condutor Infrator"
              class="text-dark"
              icon="question-circle-fill"
            ></b-icon
          ></template>
          <span class="font-weight-bold">
            {{ temValor(dataBrasil(auto_infracao_transito.prazo_fici)) }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-overlay :show="showmanowanderley" rounded="sm">
      <b-card class="mb-2" no-body>
        <b-card-header
          header-bg-variant="outline-secondary"
          header-tag="header"
          class="p-0"
          role="tab"
        >
          <h6 class="mb-0 p-1 titulo_ait" align="left">
            Condutor Infrator Identificado
          </h6>
        </b-card-header>
        <div class="p-3" v-if="!existeCondutor && itens_fici.length == 0">
          <em
            >Não houve identificação do Condutor Infrator para esse auto de
            infração</em
          >
        </div>
        <div class="p-3" v-else-if="!existeCondutor && itens_fici.length > 0">

          <em v-if="ficiRecusado()">
            O protocolo de Identificação do Condutor Infrator (FICI) foi recusado. Não existe oficialmente um Condutor Infrator identificado para esse auto de infração.
          </em>
          <em v-else>
            O protocolo de Identificação do Condutor Infrator (FICI) está pendente de registro no DETRAN. Não existe ainda, oficialmente, um Condutor Infrator identificado para esse auto de infração.
          </em>


        </div>
        <div v-else>
          <b-row class="ml-0">
            <b-col sm="4">
              <b-form-group
                label="Identificado pelo"
                label-size="sm"
                label-class="text-secondary"
              >
                <span
                  class="font-weight-bold"
                  v-if="condutor.ind_condutor_identificado_agente"
                  >Agente</span
                >
                <span class="font-weight-bold" v-else>Solicitação FICI</span>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="ml-0">
            <b-col sm="12">
              <b-form-group v-if="condutor.nome!='*'" label="Nome" label-size="sm" label-class="text-secondary" >
                <span class="font-weight-bold">
                  {{ temValor(condutor.nome) }}
                </span>
              </b-form-group>
              <span class="font-weight-bold" v-else>Houve identificação do Condutor Infrator para esse auto de infração</span>
            </b-col>    
          </b-row>

          <b-row class="ml-0">
            <b-col sm="4">
              <b-form-group
                label="CPF"
                label-size="sm"
                label-class="text-secondary"
              >
                <span class="font-weight-bold">
                  {{ temValor(condutor.cpf_condutor) }}
                </span>
              </b-form-group>
            </b-col>
          </b-row>
           <b-row class="ml-0">
            <b-col sm="4">
              <b-form-group
                label="CNH"
                label-size="sm"
                label-class="text-secondary"
              >
                <span class="font-weight-bold">
                  {{ temValor(condutor.numero_registro_cnh) }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group
                label="UF(CNH)"
                label-size="sm"
                label-class="text-secondary"
              >
                <span class="font-weight-bold">
                  {{ temValor(condutor.uf_expedicao_cnh) }}
                </span>
              </b-form-group>
            </b-col>
            <b-col v-if="condutor.pais_cnh.id"
                   sm="4">
              <b-form-group
                label="País(CNH)"
                label-size="sm"
                label-class="text-secondary"
              >
                <span class="font-weight-bold">
                  {{ temValor(condutor.pais_cnh.nome) }}
                </span>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card>

      <b-card class="mb-2" no-body>
        <b-card-header
          header-bg-variant="outline-secondary"
          header-tag="header"
          class="p-0"
          role="tab"
        >
          <h6 class="mb-0 p-1 titulo_ait" align="left">
            Principal Condutor do Veículo (na emissão da Notificação de Autuação)
          </h6>
        </b-card-header>
        <div class="p-3" v-if="!existePrincipal">
          <em>Não havia identificação do Principal Condutor do veículo no momento do registro da Notificação de Autuação desse auto de infração (informações do sistema Estadual e Nacional de trânsito)</em>
        </div>

        <div v-else>
          <b-row class="ml-0">
            <b-col sm="9">
              <b-form-group label="Nome" label-size="sm" label-class="text-secondary">
                <span v-if="proprietario" class="font-weight-bold">
                  {{ temValor(principal.nome) }}
                </span>
                <span v-else class="font-weight-bold">
                  Foi identificado Principal Condutor para o veículo no momento do registro da Notificação de Autuação (informações do sistema Estadual e Nacional de trânsito)
                </span>
              </b-form-group>
            </b-col> 
          </b-row>

          <b-row class="ml-0">
            <b-col sm="4">
              <b-form-group
                label="CPF"
                label-size="sm"
                label-class="text-secondary"
              >
                <span class="font-weight-bold">
                  {{ temValor(principal.cpf_condutor) }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group
                label="CNH"
                label-size="sm"
                label-class="text-secondary"
              >
                <span class="font-weight-bold">
                  {{ temValor(principal.numero_registro_cnh) }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group
                label="UF(CNH)"
                label-size="sm"
                label-class="text-secondary"
              >
                <span class="font-weight-bold">
                  {{ temValor(principal.uf_expedicao_cnh) }}
                </span>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <b-overlay :show="showmanowanderleyFici" size="sm" rounded="sm">
      <b-card class="mb-2" no-body>
        <b-card-header
          header-bg-variant="outline-secondary"
          header-tag="header"
          class="p-0"
          role="tab"
        >
          <h6 class="mb-0 p-1 titulo_ait" align="left">
            Solicitação FICI - Formulário de Identificação do Condutor Infrator
          </h6>
        </b-card-header>
        <div class="p-3" v-if="itens_fici.length == 0">
          <em
            >Não houve registro de solicitação de Identificação do Condutor
            Infrator para esse auto de infração</em
          >
        </div>
        <div v-else>
          <b-row>
            <b-col>
              <b-table
                stacked="sm"
                small
                bordered
                :sticky-header="true"
                :no-border-collapse="false"
                responsive
                :fields="campos_fici"
                :items="itens_fici"
              >
                <template v-slot:cell(exibirDetalhe)="row">
                  <span title="Cancelamento">
                    <b-icon
                      v-if="row.item.status_fici?.codigo_status == 2 || row.item.status_fici_sram?.codigo_status == 2"
                      class="detalhe"
                      font-scale="1.2"
                      @click="expandeDetalheFICI(row.item)"
                      :icon="
                        row.item._showDetails
                          ? 'dash-circle-fill'
                          : 'plus-circle-fill'
                      "
                    >
                    </b-icon>
                  </span>
                </template>

                <template v-slot:cell(numero_solicitacao)="row">
                  {{
                    temValor(
                      row.item.numero_solicitacao +
                        "/" +
                        row.item.ano_solicitacao
                    )
                  }}
                </template>

                <template v-slot:cell(status_parecer)="row">
                  <span v-if="row.item.status_fici">
                    {{
                      temValor(
                        row.item.status_fici
                        ? row.item.status_fici.descricao
                          : ""
                      )
                    }}
                  </span>
                </template>

                <template v-slot:cell(resgistro_sram)="row">
                  <span v-if="row.item.status_fici_sram">
                    {{
                      temValor(
                        row.item.status_fici_sram
                          ? row.item.status_fici_sram.descricao
                          : ""
                      )
                    }}
                  </span>
                  <span v-else>
                    Sem envio para o DETRAN
                  </span>
                </template>

                <template v-slot:cell(data_solicitacao_considerada)="row">
                  {{
                    temValor(
                      dataHoraBrasil(row.item.data_solicitacao_considerada)
                    )
                  }}
                </template>

                <template v-slot:cell(data_inclusao_fici_sram)="row">
                  {{
                    temValor(dataHoraBrasil(row.item.data_inclusao_fici_sram))
                  }}
                </template>

                <template v-slot:row-details="row">
                  <b-overlay :show="row.item.showmanowanderley" rounded="sm">
                    <b-card class="mb-3">
                      <b-form-row v-if="row.item.status_fici?.codigo_status == 2 && row.item.parecer_fici?.codigo"> 
                        <b-col>
                          <b-table
                            stacked="sm"
                            show-empty
                            small
                            striped
                            bordered
                            :sticky-header="true"
                            :no-border-collapse="false"
                            responsive
                            :fields="campos_fici_recusa_bhtrans"
                            :items="[row.item]"
                          >
                            <template v-slot:empty>
                              Não existem valores cadastrados
                            </template>
                            <template v-slot:cell(data_parecer_fici)="row" >
                              {{ dataHoraBrasil(row.item.data_parecer_fici)}}
                            </template>
                            <template v-slot:cell(descricao)="row">
                              {{row.item.parecer_fici.codigo}} - {{row.item.parecer_fici.descricao}}
                            </template>
                          </b-table>
                        </b-col>
                      </b-form-row>
                      <b-form-row v-if="row.item.status_fici_sram.codigo_status == 2 && row.item.errosFici.length > 0">
                        <b-col>
                          <b-table
                            stacked="sm"
                            show-empty
                            small
                            striped
                            bordered
                            :sticky-header="true"
                            :no-border-collapse="false"
                            responsive
                            :fields="campos_fici_recusa_detran"
                            :items="row.item.errosFici"
                          >
                            <template v-slot:empty>
                              Não existem valores cadastrados
                            </template>
                            <template v-slot:cell(created_at)="row">
                              {{ dataHoraBrasil(row.item.created_at) }}
                            </template>

                            <template v-slot:cell(observacao)="row">
                              {{ row.item.sram_mensagem_erro ? row.item.sram_mensagem_erro.mensagem_cidadao : row.item.observacao}}
                            </template>

                          </b-table>
                        </b-col>
                      </b-form-row>
                    </b-card>
                  </b-overlay>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col v-if="itens_fici.length > 0">
            <em style="font-size: small">
              <b-link
                size="sm"
                class="text-primary"
                target="_blank"
                href="https://servicos.pbh.gov.br/servicos/my-requests"
                title="Protocolo do Portal de Serviços da PBH - Acompanhe sua solicitação">
                * Protocolo do Portal de Serviços da PBH - Acompanhe sua
                solicitação
              </b-link></em
            >
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
    <b-row class="mt-3">
      <b-col>  
        <font-awesome-icon size="lg" :icon="['fa', 'circle-info']" class="mr-1"/>
        <u><strong>Serviços oferecidos no Portal de Serviços da PBH</strong></u>
      </b-col>
    </b-row>
    <b-card class="mb-2 mt-1" no-body>
      <b-row class="p-2">
        <b-col>
          <b-link
            size="sm"
            class="text-primary"
            style="font-weight: bold"
            target="_blank"
            href="https://servicos.pbh.gov.br/servicos/i/5e7bb88ad9521a26a9cf8c4f/5dc8470253fd6b5bbd99185f/servicos+identificacao-do-condutor-infrator-fici"
            title="Serviço FICI - Formulário de Indicação do Condutor Infrator - Portal de Serviços PBH"
          >
            <font-awesome-icon
              size="lg"
              :icon="['fa', 'arrow-up-right-from-square']"
            />
            Serviço FICI - Formulário de Indicação do Condutor Infrator - Portal
            de Serviços PBH
          </b-link>
        </b-col>
      </b-row>
      <b-row class="p-2">
        <b-col class="mt-1" sm="8">
          <p>
            Por meio do FICI, o cidadão pode indicar o condutor que estava
            conduzindo o seu veículo no momento do cometimento da infração. Se
            aplicavel, registre uma solicitação para identificar o Condutor
            Infrator dessa infração no Portal de Serviços da PBH.
          </p>
        </b-col>
        <b-col>
          <b-row class="text-center">
            <b-col>
              <b-link @click="verificarFormularioFici('simples')">
                <font-awesome-icon
                  size="lg"
                  :icon="['fa', 'print']"
                  title="Formulário para impressão (simples)"
                />
              </b-link>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <b-col>
              <strong>Formulário para impressão (simples)</strong>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="p-2">
        <b-col class="mt-1" sm="8">
          <p>
            Já abriu sua solicitação? Para mais detalhes sobre sua solicitação
            já aberta, acesse o Portal de Serviços da PBH com os dados do
            protocolo e/ou acesso GovBr (vide Área de Relacionamento).
          </p>
        </b-col>
        <b-col>
          <b-row class="text-center">
            <b-col>
              <b-link @click="verificarFormularioFici('preenchido')">
                <font-awesome-icon
                  size="lg"
                  :icon="['fa', 'print']"
                  title="Formulário para impressão (simples)"
                />
              </b-link>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <b-col>
              <strong>Formulário para impressão (pré-preenchido)</strong>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <modal-espelho-fici ref="modalEspelhoAit"></modal-espelho-fici>
  </div>
</template>

<script>
import AutoInfracaoTransito from "@/models/AutoInfracaoTransito";
import PessoaAutoInfracaoTransito from "@/models/PessoaAutoInfracaoTransito";
import { helperDatas } from "@/helpers";
import helpers from "@/helpers";
import modalEspelhoFici from "./_modalEspelhoFici";
import { helperMascaras } from "@/helpers/mascaras.js";

export default {
  name: "CondutorAba",

  components: {
    modalEspelhoFici,
  },

  props: {
    auto_infracao_transito: {
      type: Object,
      default: function () {
        return new AutoInfracaoTransito();
      },
    },
  },

  data() {
    return {
      options_identificacao: [
        { text: "Agente", value: true },
        { text: "Solicitação FICI", value: false },
      ],
      carregado: false,
      condutor: new PessoaAutoInfracaoTransito(),
      principal: new PessoaAutoInfracaoTransito(),
      titular: new PessoaAutoInfracaoTransito(),
      pessoas_auto_infracao_transito: [],

      showmanowanderley: false,
      showmanowanderleyFici: false,

      campos_fici: [
        {
          key: "exibirDetalhe",
          label: "",
          class: "text-center",
          thStyle: { textAlign: "center" },
        },
        {
          key: "numero_solicitacao",
          label: "Número Solicitação",
          class: "text-center",
        },
        {
          key: "protocolo_bhdigital",
          label: "Protocolo *",
          class: "text-center",
        },
        {
          key: "data_solicitacao_considerada",
          label: "Data Solicitação",
          class: "text-center",
        },
        {
          key: "status_parecer",
          label: "Parecer BHTRANS",
          class: "text-center",
        },
        {
          key: "resgistro_sram",
          label: "Parecer DETRAN",
          class: "text-center",
        },
        {
          key: "data_inclusao_fici_sram",
          label: "Inclusão FICI no DETRAN",
          class: "text-center",
        },
      ],

      campos_fici_recusa_bhtrans: [
        {
          key: "data_parecer_fici",
          label: "Data da Recusa BHTRANS",
          class: "text-center col-sm-3",
        },
        {
          key: "descricao",
          label: "Motivo da Recusa BHTRANS",
          class: "text-center",
        },
      ],

      campos_fici_recusa_detran: [
        {
          key: "created_at",
          label: "Data do Retorno do DETRAN",
          class: "text-center col-sm-3",
        },
        {
          key: "observacao",
          label: "Retorno do DETRAN",
          class: "text-center",
        },
      ],

      itens_fici: [],
      existeCondutor: false,
      existePrincipal: false,
      listaCpfCnpj: [],
      proprietario: false
    };
  },

  computed: {
    mobile() {
      return helpers.isMobile();
    },
  },

  created() {
    this.cpfCnpf();
  },

  methods: {
    dataBrasil(valor) {
      return helperDatas.dataBrasil(valor);
    },

    dataHoraBrasil(valor) {
      return helperDatas.dataHoraBrasil(valor);
    },

    cpfCnpf() {
      var keys = Object.keys(this.$store.getters.userInfo.attributes);
      const result = keys.filter(
        (element) => element.substring(10, 0) == "govbr_cnpj"
      );
      this.listaCpfCnpj = [];
      this.listaCpfCnpj.push(
        helperMascaras.cnpjCpf(this.$store.getters.userInfo.preferred_username)
      );
      if (result.length > 0) {
        result.forEach((element) => {
          this.listaCpfCnpj.push(
            helperMascaras.cnpjCpf(element.substring(25, 11))
          );
        });
      }
    },

    verificaProprietario(){
      return this.$api.Multa.verificaProprietario({
        hash: this.auto_infracao_transito.hash,
        listadoc: this.listaCpfCnpf(),
      })
        .then(async (response) => {
          if (response.data.success && response.data.data) {
            this.proprietario = response.data.data.possuidor;
          }
        })
        .catch(() => {});
    },

    loadInfos() {
      if (!this.carregado) {
        this.carregado = true;
        this.showmanowanderley = true;
        this.showmanowanderleyFici = true;

        this.$api.Multa.buscarPessoasAit({
          hash: this.auto_infracao_transito.hash,
          ld:this.listaCpfCnpf()
        })
          .then(async (response) => 
          {
            this.showmanowanderley = false;
            
            if (response.data.success && response.data.data) 
            {
           
              this.condutor = new PessoaAutoInfracaoTransito(
                response.data.data.find((x) => {
                  return x.tipo_pessoa_veiculo.codigo == 8;
                })
              );

              this.verificaDadosCondutor(this.condutor);

              var listaPessoaPrincipal = response.data.data.filter((x) => {
                return x.tipo_pessoa_veiculo.codigo == 9;
                })

              listaPessoaPrincipal.forEach(element=>{
                if(element.notificacao_principal_condutor.length > 0){
                  var principal = element.notificacao_principal_condutor.filter((x) => {
                    return x.lote_remessa_correio.tipo_notificacao.tipo_nit_nap == 'NIT';
                  })
                }
                if(principal.length > 0){
                  this.principal = new PessoaAutoInfracaoTransito(element);
                }
              })

              this.verificaDadosPrincipal(this.principal);

            }
          })          
          .catch(() => {
            this.showmanowanderley = false;
          });

        this.$api.Multa.buscarSolicitacaoFici({
          hash: this.auto_infracao_transito.hash,
        })
          .then(async (response) => {
            this.showmanowanderleyFici = false;
            if (response.data.success && response.data.data) {
              response.data.data.forEach((element) => {
                if(element.status_fici.codigo_status != '3'){
                  element.showmanowanderley = false;
                  element.errosFici = [];
                  element._showDetails =false;
                  this.itens_fici.push(element)
                }
              });
            }
          })

          .catch(() => {
            this.showmanowanderleyFici = false;
          });

        this.$api.Multa.buscarTitularesAit({
          hash: this.auto_infracao_transito.hash,
        })
          .then(async (response) => {
            this.showmanowanderleyFici = false;
            if (response.data.success && response.data.data) {
              this.titular = new PessoaAutoInfracaoTransito(response.data.data);
            }
          })
          .catch(() => {
            this.showmanowanderleyFici = false;
          });

          this.verificaProprietario();
      }
    },

    buscarErrosFici(item) {
      return this.$api.Multa.buscarDetalhamentoErros({
        hash: this.auto_infracao_transito.hash,
        solicitacao_id: item.id,
      })
        .then(async (response) => {
          if (response.data.success && response.data.data) {
            response.data.data.errosFici.forEach((element) => {
              element.observacao =
                element.codigo_erro_sram + " - " + element.observacao;
              item.errosFici.push(element);
            });
          }
        })
        .catch(() => {});
    },

    listaCpfCnpf() {
      var keys = Object.keys(this.$store.getters.userInfo.attributes);
      const result = keys.filter(
        (element) => element.substring(10, 0) == "govbr_cnpj"
      );
      let listaCpfCnpj = [];
      listaCpfCnpj.push(this.$store.getters.userInfo.preferred_username);
      if (result.length > 0) {
        result.forEach((element) => {
          listaCpfCnpj.push(element.substring(25, 11));
        });
      }
      return listaCpfCnpj;
    },     

    expandeDetalheFICI(item) {
      if (!item._showDetails) {
        item.errosFici = [];
        this.obterDadosAoExpandir(item);
      }
      item._showDetails = !item._showDetails;
    },

    async obterDadosAoExpandir(item) {
      item.showmanowanderley = true;
      await this.buscarErrosFici(item);
      item.showmanowanderley = false;
    },

    verificarFormularioFici(tipo_formulario) {
      //var titular = null;
      var dados = null;
      if (tipo_formulario != "simples") {
        //titular = this.titular;
        dados = {hash:this.auto_infracao_transito.hash};
      }
      if (this.mobile) {
        this.downloadFormularioFici(dados);
      } else {
        this.exibirFormularioFici(dados);
      }
    },

    exibirFormularioFici(dados) {
      this.$refs.modalEspelhoAit.abrirSintetico(dados, this.listaCpfCnpf());
    },

    downloadFormularioFici(dados) {
      this.$api.Multa.gerarFormularioFici({ dados: dados, listadoc: this.listaCpfCnpf() })
        .then((response) => {
          var a = document.createElement("a");
          a.href = "data:application/pdf;base64," + response.data.data;
          a.download =
            this.auto_infracao_transito.num_ait_composto + "_copia_autuacao";
          a.click();
        })
        .catch(() => {});
    },

    temValor(valor) {
      return valor ? valor : "-";
    },

    verificaDadosCondutor(obj) {
      if (
        obj.nome ||
        obj.cpf_condutor ||
        obj.numero_registro_cnh ||
        obj.uf_expedicao_cnh ||
        obj.tipo_documento_pessoa.descricao ||
        obj.numero_documento
      ) {
        this.existeCondutor = true;
      }
    },

    verificaDadosPrincipal(obj) {
      if (
        obj.nome ||
        obj.cpf_condutor ||
        obj.numero_registro_cnh ||
        obj.uf_expedicao_cnh
      ) {
        this.existePrincipal = true;
      }
    },
       
    ficiRecusado() 
    {
      let fici = this.itens_fici[this.itens_fici.length-1];
      if( fici.status_fici.codigo_status == 2 || (fici.status_fici_sram && fici.status_fici_sram.codigo_status == 2) ) return true;
      else return false;
    }

  },
};
</script>

<style scoped>
</style>